import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PageWrapper from '../layouts/Index';
import PageTitle from '../components/PageTitle';
import useCustomAlert from '../components/Alert2';
import { paymentSchedulePlans } from '../services/oxygenRetailServices';
import { useNavigate } from 'react-router-dom';

const OxygenPaymentSchedulePlan = () => {
    const customAlert = useCustomAlert();
    const navigate = useNavigate();
    const precustomerId = useSelector((state) => state?.precustomer?.precustomerData?.precustomer?.precustomerId);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [paymentData, setPaymentData] = useState(null);
    // console.log("paymentData", paymentData);


    const handlePaymentSchedulePlans = async() => {
        setLoading(true);
        const payload = {
            preCustomerId: Number(precustomerId),
        }
        
        const response = await paymentSchedulePlans(payload);
        
        if(response?.status === true) {
            setLoading(false);
            setPaymentData(response?.data);
        }else{
            setLoading(false);
            customAlert.showToast("error", `${response?.message}` || "Failed to fetch payment plans..!");
            setErrorMessage(response?.message || "Failed to fetch payment plans..!");
        }

    }

    useEffect(() => {
        handlePaymentSchedulePlans();
    }, [precustomerId, ]);


  return (
    <PageWrapper>
        <PageTitle title={`Payment Schedule Plan`} />
        {loading ? (
            <p className='text-center'>Fetching payment plans...</p>
        ):errorMessage ? (
            <div className="alert alert-danger" role="alert">
            {errorMessage}
        </div>
        ):(
            <div className="container my-5">
                <h3 className="mb-4 font-weight-bold mb-5">Repayment Summary</h3>

                {/* Summary Section */}
                <div className="row mb-4">
                    <div className="col-md-3">
                        <div className="card shadow-sm p-3">
                            <h6>Monthly Repayment</h6>
                            <p className="fw-bold text-primary">₦{paymentData?.monthlyRepayment?.toLocaleString()}</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card shadow-sm p-3">
                            <h6>Total Repayment</h6>
                            <p className="fw-bold text-success">₦{paymentData?.totalRepayment?.toLocaleString()}</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card shadow-sm p-3">
                            <h6>Downpayment</h6>
                            <p className="fw-bold text-danger">₦{paymentData?.downpayment?.toLocaleString()}</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card shadow-sm p-3">
                            <h6>Equity Contribution</h6>
                            <p className="fw-bold text-secondary">₦{paymentData?.equityContribution?.toLocaleString()}</p>
                        </div>
                    </div>
                </div>

                {/* Table Section */}
                <h4 className="mb-3 font-weight-bold mb-5">Repayment Schedule</h4>
                <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                        <thead className="font-weight-bold">
                        <tr>
                            <th>S/N</th>
                            <th>Due Date</th>
                            <th>Monthly Amount</th>
                            <th>Monthly Interest</th>
                            <th>Total Payment</th>
                            <th>Remaining Balance</th>
                        </tr>
                        </thead>
                        <tbody>
                        {paymentData?.repaymentSchedule?.map((item) => (
                            <tr key={item?.installmentNumber}>
                            <td>{item?.installmentNumber}</td>
                            <td>{new Date(item?.dueDate).toLocaleDateString()}</td>
                            <td>₦{item?.monthlyAmount.toLocaleString()}</td>
                            <td>₦{item?.monthlyInterest.toLocaleString()}</td>
                            <td>₦{item?.montlyTotalPayment.toLocaleString()}</td>
                            <td>₦{item?.remainingBalance.toLocaleString()}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

                {/* Action Buttons */}
                <div className="d-flex justify-content-center gap-3 mt-6 mb-5">
                    <button className="btn btn-success" onClick={() => navigate("/liveness-check")}>Proceed</button>
                    <button className="btn btn-primary" onClick={() => navigate("/oxygen-devices")}>Choose a New Device</button>
                    <button className="btn btn-danger" onClick={() => navigate("/oxygen-devices")}>Cancel</button>
                </div>
            </div>
        )
        
        }
     </PageWrapper>
  )
}

export default OxygenPaymentSchedulePlan;